import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartSimple } from '@fortawesome/pro-light-svg-icons/faChartSimple';
import { faChartLineUp } from '@fortawesome/pro-light-svg-icons/faChartLineUp';
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink';
import { TypedMemo } from '../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole handoff; each part uses its own slice of it */
import styles from './MobileApps.module.scss';
/* eslint-enable css-modules/no-unused-class */

const bold = (chunks: React.ReactNode[]) => <b>{chunks}</b>;

/** Design 1b: what the apps give, in place of the steps. */
const HandoffBenefitsComponent: React.FC = () => {
  const intl = useIntl();

  const rows = [
    {
      key: 'portals',
      icon: faChartSimple,
      text: intl.formatMessage(
        {
          id: 'app.sml.mobileApps.benefits.portals',
          defaultMessage: '<b>Connect Spotify for Artists</b>, which a browser cannot do.',
        },
        { b: bold }
      ),
    },
    {
      key: 'watchlist',
      icon: faChartLineUp,
      text: intl.formatMessage({
        id: 'app.sml.mobileApps.benefits.watchlist',
        defaultMessage: 'Your watchlist and movers, wherever you are.',
      }),
    },
    {
      key: 'smartlinks',
      icon: faLink,
      text: intl.formatMessage({
        id: 'app.sml.mobileApps.benefits.smartlinks',
        defaultMessage: 'Smartlinks and posts from your phone.',
      }),
    },
  ];

  return (
    <ul className={styles.benefits}>
      {rows.map((row) => (
        <li key={row.key} className={styles.benefit}>
          <span className={styles.benefitIcon}>
            <FontAwesomeIcon icon={row.icon} fixedWidth />
          </span>
          <span>{row.text}</span>
        </li>
      ))}
    </ul>
  );
};

export const HandoffBenefits = TypedMemo(HandoffBenefitsComponent);
